<script setup lang="ts">
const snowflakes = Array.from({ length: 35 }).map(() => ({
  style: {
    left: `${Math.random() * 100}%`,
    animationDuration: `${Math.random() * 10 + 5}s`, // entre 5 y 10s
    animationDelay: `${Math.random() * 10}s`, // delay negativo para que empiecen ya cayendo
    width: `${Math.random() * 6 + 4}px`, // entre 4 y 10px
    height: `${Math.random() * 6 + 4}px`,
    opacity: Math.random() * 0.5 + 0.3
  }
}))
</script>

<template>
  <div class="snow-container">
    <div 
      v-for="(flake, index) in snowflakes" 
      :key="index" 
      class="snowflake"
      :style="{
        ...flake.style,
        width: flake.style.width,
        height: flake.style.width // Asegurar que sean redondos
      }"
    ></div>
  </div>
</template>

<style scoped>
.snow-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
  z-index: 50;
}

.snowflake {
  position: absolute;
  top: -20px;
  background: #e2e8f0; /* Color gris azulado claro para verse en fondo blanco */
  border-radius: 50%;
  filter: blur(1px);
  animation: fall linear infinite;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
}

@keyframes fall {
  0% {
    transform: translateY(-20px) translateX(-10px);
  }
  25% {
    transform: translateY(25vh) translateX(10px);
  }
  50% {
    transform: translateY(50vh) translateX(-10px);
  }
  75% {
    transform: translateY(75vh) translateX(10px);
  }
  100% {
    transform: translateY(100vh) translateX(-10px);
  }
}
</style>

